export const LOCATION_MAP_HEIGHT = 600;
export const LOCATION_MAP_SCALE = 147;
export const LOCATION_MAP_WIDTH = 800;
